export const clamp = (value: number, min: number, max: number): number =>
    value < min ? min : value > max ? max : value;

export const clamp_0to1 = (value: number): number => clamp(value, 0, 1);

export const clamp_neg1to1 = (value: number) => clamp(value, -1, 1);
